import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const shiranTrades: SeasonTrades[] = [
  {
    season: "2016/17",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Otto Porter Jr",
        gotInReturn: "Marc Gasol",
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Derrick Favors",
        gotInReturn: "Trevor Ariza",
      },

      {
        otherTeam: manager.zeev,
        sentAway: "Nikola Jokic and Trevor Ariza",
        gotInReturn: "Kawhi Leonard and Derrick Favors",
        amongWorstTrades: true
      },
    ],
  },
  {
    season: "2017/18",
    allTrades: [
      {
        otherTeam: manager.kobe,
        sentAway: "Larry Nance Jr",
        gotInReturn: "Bobby Portis",
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Clint Capela and Jonas Valanciunas",
        gotInReturn: "Bradley Beal and TJ Warren",
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Jimmy Butler and Marquese Chriss",
        gotInReturn: "Al Horford, Evan Fournier and Larry Nance Jr",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Rondae Hollis-Jefferson and Jrue Holiday",
        gotInReturn: "Paul George and DeAron Fox",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.idan,
        sentAway: "Al Horford and Richaun Holmes",
        gotInReturn: "Jaylen Brown and Bobby Portis",
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Evan Fournier",
        gotInReturn: "TJ Warren",
      },
      {
        otherTeam: manager.mati,
        sentAway: "TJ Warren",
        gotInReturn: "Julius Randle",
      },
    ],
  },
  {
    season: "2018/19",
    allTrades: [
      {
        otherTeam: manager.idan,
        sentAway: "Paul George",
        gotInReturn: "John Collins",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Tim Hardaway Jr",
        gotInReturn: "Collin Sexton",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Kawhi Leonard",
        gotInReturn: "Lebron James",
      },
    ],
  },
  {
    season: "2019/20",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "John Collins",
        gotInReturn: "Lonzo Ball and DeMar DeRozan",
      },
    ],
  },
  { season: "2020/21", allTrades: [] },
  {
    season: "2021/22",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Dejounte Murray, Khris Middleton and Daniel Gafford",
        gotInReturn:
          "Anthony Davis, Russell Westbrook, Christian Wood and Kyle Kuzma",
        amongBestTrades: true,
      },
    ],
  },
  { season: "2022/23", allTrades: [] },
  { season: "2023/24", allTrades: [] },
];
